import React from 'react';
import { FaSearch } from 'react-icons/fa';

const ReportFilterBar = ({
  searchTerm = '',
  onSearchChange,
  searchPlaceholder = 'Search reports by date or author...',
  statusFilter = 0,
  onStatusFilterChange,
  statusOptions = [
    { value: 0, label: 'Active' },
    { value: 1, label: 'Archived' },
  ],
  children,
}) => {
  return (
    <div className="bg-white p-3.5 rounded-xl border border-aimhi-border shadow-xs mb-4 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="relative w-full sm:w-72">
        <FaSearch className="absolute left-3 top-2.5 text-xs text-gray-400 pointer-events-none" />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange?.(e.target.value)}
          className="w-full py-1.5 pl-8 pr-7 text-xs bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-aimhi-info/20 focus:border-aimhi-info transition-all text-aimhi-textlight-neutral placeholder:text-gray-400"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={() => onSearchChange?.('')}
            className="absolute right-2.5 top-1.5 text-xs text-gray-400 hover:text-gray-600 font-bold"
          >
            ✕
          </button>
        )}
      </div>

      <div className="flex items-center gap-2 self-end sm:self-auto">
        {children}
        <label htmlFor="report-status-filter" className="text-xs font-semibold text-aimhi-textlight-neutral shrink-0">
          View:
        </label>
        <select
          id="report-status-filter"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange?.(Number(e.target.value))}
          className="px-3 py-1.5 text-xs font-medium border border-gray-300 rounded-lg bg-white text-aimhi-textlight-neutral focus:outline-none focus:ring-2 focus:ring-aimhi-info/20 focus:border-aimhi-info cursor-pointer transition-all"
        >
          {statusOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ReportFilterBar;
